export class CacheBucket extends Set<string> {}
